import {
  ActionIcon,
  Box,
  Button,
  Card,
  Container,
  CopyButton,
  Group,
  Text,
  TextInput,
  Title,
  Tooltip,
  rem,
} from '@mantine/core';
import { IconCheck, IconCopy, IconCreditCard, IconLink } from '@tabler/icons-react';

export function SlideCredits({ user, openUpgradeModal }) {
  return (
    <Container size="lg" pos="relative" px="lg" py="xl">
      <Title order={2} fz={{ base: rem(20), sm: rem(30) }} ta="center" mb="xl" fw={400}>
        Slide credit balance
      </Title>
      <Box pos="relative" style={{ zIndex: 1 }}>
        <Group align="center" justify="center" mb="md" gap="xs">
          <IconCreditCard size={50} />
          <Title ta="center" fz={{ base: rem(30), sm: rem(40) }}>
            {user.app_credit_remaining} slide credits
          </Title>
        </Group>

        <Text size="lg" c="dimmed" mb="md" fz={{ base: rem(15), sm: rem(20) }}>
          Each credit represents one slide in a Google Slides or Web Slides presentation.
        </Text>

        <Card mb="lg">
          <Group justify="center" align="center">
            <Text flex="1">Upgrade to one of our plans for more or unlimited credits.</Text>
            <Button
              size="lg"
              variant="gradient"
              gradient={{ from: '#fe9920', to: '#ff2a77', deg: 90 }}
              onClick={openUpgradeModal}
            >
              Upgrade
            </Button>
          </Group>
        </Card>

        <Text size="lg" c="dimmed" mb="md" fz={{ base: rem(15), sm: rem(20) }}>
          Refer a friend using the link below. Both of you will earn 20 slide credits when your
          friend signs up for a Slides Generator account using the link.
        </Text>

        <TextInput
          value={`${window.location.origin}/users/sign_up?rToken=${user.referral_code}`}
          mb="md"
          size="lg"
          leftSection={<IconLink style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
          rightSection={
            <CopyButton
              value={`${window.location.origin}/users/sign_up?rToken=${user.referral_code}`}
              timeout={2000}
            >
              {({ copied, copy }) => (
                <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="right">
                  <ActionIcon color={copied ? 'teal' : 'gray'} variant="subtle" onClick={copy}>
                    {copied ? (
                      <IconCheck style={{ width: rem(16) }} />
                    ) : (
                      <IconCopy style={{ width: rem(16) }} />
                    )}
                  </ActionIcon>
                </Tooltip>
              )}
            </CopyButton>
          }
        />
      </Box>
    </Container>
  );
}
